"use strict";
var ACC;
ACC.validation = {
	_autoload: [
		"bindPhoneInputRestriction",
		"bindInputEmptyIndicators"
	],

	// Add your constants here.
	_constants: {
	},

	// Populate on the fly for cached elements such as multiple use jQuery look-ups.
	_cache: {},

 	// Control phone number inputs.
	bindPhoneInputRestriction: function() {
		// Some popups are injecting content through .html() on Bootstrap show.bs.modal
		// event. These forms do not get the event assignment from this function.
		// Those events will be assigned separately in appropriate code.
		ACC.validation.preventNonPhoneInput($("input[type=tel]"));
	},

	// Add standard functionality for form inputs.
	bindInputEmptyIndicators: function() {
		var VA = ACC.validation;
		/*
			Note: We should be able to bind empty indicator functionality as global standard using
			only the one-liner shown below in this comment. Unfortunately due to the fragmented and
			somewhat random JS code implementations, it is currently safer to limit binding to
			as an isolated approach, using specific jQuery lookups below (the uncomment bit).

			If a significant code clean is implemented all Empty Indicator functionality can be
			applied using this single line. Leaving as commented out code in the hope that will happen.

			ACC.validation.applyInputEmptyIndicators($("input[type=text], input[type=tel]"));
		*/

		// Click and Collect and Delivery Forms
		VA.applyInputEmptyIndicators($("#tjxClickCollectForm").find("input[type=text]"));
		VA.applyCandCPhoneInputEmptyIndicators($("#tjxClickCollectForm").find("input[type=tel]"));
        VA.applyInputEmptyIndicators($("#tjxCollectionPointForm").find("input[type=text]"));
        VA.applyCandCPhoneInputEmptyIndicators($("#tjxCollectionPointForm").find("input[type=tel]"));
		VA.applyInputEmptyIndicators($("#i18nAddressForm").find("input[type=text], input[type=tel]").filter("input[id!=address-postcode]"));
		// Delivery Postcode is a special case
		VA.handlePostcodeValidation($("#i18nAddressForm").find("input[id=address-postcode]"));
		VA.applyInputEmptyIndicators($("#storeFinderForm").find("input[type=text], input[type=tel]"));
		VA.applyInputEmptyIndicators($("#tjxUpdateProfileForm").find("input[type=text], input[type=tel]"));
		// Registration
		VA.applyInputEmptyIndicators($("#tjxRegisterForm").find("input[type=tel]"));
		// Contact Us
		VA.applyInputEmptyIndicators($("#tjxContactUsForm")
			.find("input[type=text], input[type=tel], input[type=email]"));
		VA.applyInputEmptyIndicators($("#tjxForgottenPwdForm").find("input[type=email]"));
    },

	// Post code validation is a special case as there may be
	// normal post code validation but also a restricted one
	// via the additional-regex attribute on the input tag
	handlePostcodeValidation: function($fields) {
		$fields = $fields instanceof jQuery === false ? $($fields) : $fields;
		$fields.on('blur.validatePostcode', function () {
			var $this = $(this);
			var VA = ACC.validation;
			VA.validateInput($this, VA.inputFieldErrorViewHandler);
		});
	},

	// Check input field validity.
	// @$field (jQuery element) input element to be validated.
	// @handler (Function) Optional callback to handle the outcome. Recieves two arguments: (jQuery) $input, (Boolean) valid_status
	// Returns (Boolean) to indicate valid status.
	validateInput: function($field, handler) {
		// if $field passed is not a jQuery object, we make it one
		$field = $field instanceof jQuery === false ? $($field) : $field;
		var valid = true;
		var value = $field.val();
		var regex = $field.data('validation-regex') || $field[0].getAttribute('validation-regex'),
			additionalRegex = $field.data("additional-regex");
		var message,
			errorRegex = $field.data("error-regex"),
			errorAdditionalRegex = $field.data("error-additional-regex");

        if (regex) {
			if (value.match(new RegExp(regex, 'iy')) === null) {
				valid = false;
			} else {
				valid = true;
			}
			// Get the error message if it isn't valid
			message = !valid && errorRegex;
        }

		// Only do this data-additional-regex check if the initial regex was successful
		if (valid && additionalRegex) {
			// NOTE: This is an inverse validation
			valid = !(new RegExp(additionalRegex, "ig")).test(value);
			message = !valid && errorAdditionalRegex;
		}

		if(arguments.length > 1) {
			handler($field, valid, message);
		}
		return valid;
	},

	// Handles input element red cross/green tick visual changes.
	// @$input (jQuery Element) The input element to act upon.
	// @valid (Boolean) Indicates validation state of input element.
	// @message (String) Custom message to alternative to standard error.
	// Note: Not passing @valid means the field will simply clear any previous message and state.
	inputFieldErrorViewHandler: function($input, valid, message) {
		// if $input passed is not a jQuery object, we make it one
		$input = $input instanceof jQuery === false ? $($input) : $input;
		var error = arguments.length > 2 && message ? message : $input.data('error');
		var $parentClass = $input.closest(".form-group");
		var $errorMessage = $parentClass.find("[id$='error-message']").first();
		var $help = $("<div class=\"help-block\"></div>");
		var $icon = $('<i class="fa"></i>');
		var good = "icon icon-check-circle tick";
		var bad = "icon icon-cancel-circled error";

		// Always remove any existing (jQuery won't complain if not found)
		$parentClass.find('i').remove();
		$parentClass.find('div.help-block').remove();
		$parentClass.removeClass('has-error');

		// Add a new icon and set up state.
		$parentClass.prepend($icon);
		$help.empty();

		if(arguments.length > 1) {
			if(valid) {
				$icon.addClass(good);
				$input.attr('aria-invalid', 'false');
	 		}
			else {
				if($errorMessage.length > 0) {
					$errorMessage.append($help);
				} else {
					$parentClass.append($help);
				}
			
				$icon.addClass(bad);
				$parentClass.addClass('has-error');
				if(error) {
					$help.append("<span>" +  error + "</span>");
				}

				// If there is an error in the field set aria-invalid to true
				// Delay added so that the speech for the next field is uninterrupted by the aria-invalid change
				// Done to maintain current screenreader behaviour on the site
				setTimeout(function() {
					$input.attr('aria-invalid', 'true');
				}, 300);	
			}
		} else {
			// Added to cover scenario where we are just clearing the state 
			// with "VA.inputFieldErrorViewHandler($this);" otherwise non-mandatory fields will remain aria-invalid="true"
			$input.attr('aria-invalid', 'false');
		}
	},

	// Control show/hide of red cross/green tick icons for empty/filled input elements.
	// @$fields (jQuery Collection) Input fields to receive this functionality.
	applyInputEmptyIndicators: function($fields) {
		$fields = $fields instanceof jQuery === false ? $($fields) : $fields;
		$fields.blur(function(){
			var VA = ACC.validation;
			var $this = $(this);
			var value = VA.cleanInput($this);
			var mandatory = $this.data("mandatory");
			var errorMsgRegex = $this.data('error-regex');

			if(value.length > 0) {
				// If it has a value pass off to field validation.
				// If regex shows valid or field doesn't have one
				// we'll see a green tick.
				VA.inputFieldErrorViewHandler($this, VA.validateInput($this, VA.inputFieldErrorViewHandler), errorMsgRegex);
			}
			else {
				if(mandatory) {
					// Display red cross because we should have something.
					VA.inputFieldErrorViewHandler($this, false);
				}
				else {
					// Just clears the previous state.
					VA.inputFieldErrorViewHandler($this);
				}
			}
		});
	},

	// Prevents a user typing some (mainly non-numeric) characters into a phone field.
	// @$input (jQuery Collection) input(s) requiring this event.
	preventNonPhoneInput: function ($input) {
		$input.on("keydown", function(e) {
			// ctrlKey for Windows, metaKey for Mac
			var ctrlKey = e.ctrlKey || e.metaKey;
            var shiftKeyOnly = e.shiftKey && !e.altKey && !ctrlKey;
            var modifierKey = e.shiftKey || e.altKey || ctrlKey;
            var noModifierKey = !e.shiftKey && !e.altKey && !ctrlKey;

			// Allow: delete (46), backspace (8), tab (9), escape (27), enter (13) and space (32)
			if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 32]) !== -1 ||
                // Allow decimal point (numpad) and period
                (e.keyCode === 110) ||
                (e.keyCode === 190 && noModifierKey) ||
				// Allow: Ctrl+A
				(e.keyCode === 65 && ctrlKey) ||
				// Allow: Ctrl+C
				(e.keyCode === 67 && ctrlKey) ||
				// Allow: Ctrl+X
				(e.keyCode === 88 && ctrlKey) ||
				// Allow: Ctrl+V
				(e.keyCode === 86 && ctrlKey) ||
				// Allow: + symbol (107 - NumpadAdd, 61 - Equal Firefox, 187 - Equal)
                (e.keyCode === 107) ||
				(e.keyCode === 61 && shiftKeyOnly) ||
				(e.keyCode === 187 && shiftKeyOnly) ||
                // Allow parentheses (57 - left, 48 - right)
                (e.keyCode === 57 && shiftKeyOnly) ||
                (e.keyCode === 48 && shiftKeyOnly) ||
				// Allow: home, end, left, right
				(e.keyCode >= 35 && e.keyCode <= 39)) {

				// let it happen, don't do anything
				return;
			}
			// Ensure that it is a number and stop the keypress
			if ((modifierKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault();
			}
		});
	},

	// Sometimes we want to clean the input before validating.
	// Handled all exception and special cleaning here.
	// @$input (jQuery Object) Input field
	cleanInput: function($input) {
		var VA = ACC.validation;
		var value = $.trim($input.val());

		// Phone numbers need special handling.
		if($input.is("[type=tel]")) {
			value = VA.cleanPhoneInput($input);
			$input.val(value); // Make sure the view is updated to reflect.
		}

		return value;
	},

	// Before we allow phone validation, clean input according to rules in TJX-310
	// @$input (jQuery Collection) input(s) requiring this event.
	cleanPhoneInput: function($input) {
		var value = $input.val();
		value = value.replace(/\s/g,""); // Strip whitespace
		value = value.replace(/^\(0\)(.*)$/, "0$1"); // If (0) at start, remove the brackets and leave 0
		value = value.replace(/\(0\)/g, ""); // If (0) not at start, remove all (0)
		value = value.replace(/\(|\)/g, ""); // Remove all remaining brackets
		return value;
	},

	// Check name input field validity (has no RegEx on field).
	// @$field (jQuery element) input element to be validated.
	// @handler (Function) Optional callback to handle the outcome. Recieves two arguments: (jQuery) $input, (Boolean) valid_status
	// Returns (Boolean) to indicate valid status.
	name: function($field, handler) {
		var value = $field.val();
		var valid = value.length > 1 && value.length < 255;

		if(arguments.length > 1) { handler($field, valid); }
		return valid;
	},

	// Due to required design inconsistencies we're having to overload
	// handling specifically for the Phone input on CandC details.
	applyCandCPhoneInputEmptyIndicators: function($field) {
		$field.on("blur", function() {
			ACC.validation.candcPhoneInput($(this));
		});
	},

	candcPhoneInput: function($field) {
		var VA = ACC.validation;
		var value = VA.cleanInput($field);
		var valid = true;

		if(value) {
			valid = VA.validateInput($field, VA.inputFieldErrorViewHandler);
		}
		else {
			VA.inputFieldErrorViewHandler($field, false, $field.data("validmessage"));
			valid = false;
		}

		return valid;
	},

	// Check password input field validity.
	// @$field (jQuery element) input element to be validated.
	passwordInput: function($field) {
		var errorMsg = $field.data('error');
		var value = $.trim($field.val());
		var pwdProperty = $('#passwordRegex').text().trim();
		var passwordRegex = new RegExp(pwdProperty);
		var valid = (value !== '' && value.length > 7 && passwordRegex.test(value));
		if(value.length) {
			errorMsg = $field.data('invalidpattern');
		}
		ACC.validation.inputFieldErrorViewHandler($field, valid, errorMsg);
	},

	checkPassword: function($element) {
		var $obj = $element;
		var $parentClass = $obj.closest(".form-group");
		var PW_INPUT = '#tjxGuestRegisterForm #registerPassword';
		var pwLength = $(PW_INPUT).val().length;
		var checkPwLength = $obj.val().length;
		var errorMsg = $obj.data('error');
		var divStr = "<div class=\"help-block\"><span>" + errorMsg + "</span></div>";
		var pwVal = '';
		var checkPwVal = '';

		$parentClass.find('div.help-block span').html('');
		$parentClass.removeClass('has-error');
		$parentClass.find('i').remove();

		if (checkPwLength === pwLength) {
			pwVal = $(PW_INPUT).val();
			checkPwVal = $obj.val();
			if (pwVal === checkPwVal) {
				$parentClass.find('div.help-block span').html('');
				$parentClass.removeClass('has-error');
				$parentClass.prepend('<i class="check-pw tick icon icon-check-circle"></i>');
			} else {
				$parentClass.append(divStr);
				$parentClass.addClass('has-error');
				$parentClass.prepend('<i class="icon icon-cancel-circled error"></i>');
			}
		} else if (checkPwLength > pwLength) {
			$parentClass.append(divStr);
			$parentClass.addClass('has-error');
			$parentClass.prepend('<i class="icon icon-cancel-circled error"></i>');
		}
	}

};
